import { ArrowUpRight } from "lucide-react";
import { TERMITE_LINKS } from "../../data/site";
import { Reveal } from "./Motion";

// Maillage vers les sites termites de Termite Habitat 33
const pick = (zone) => {
  if (zone === "bassin-arcachon") return [2, 0, 3, 5];
  if (zone === "bordeaux") return [1, 3, 0, 4];
  if (zone === "medoc" || zone === "libourne") return [0, 3, 4, 6];
  return [0, 1, 3, 5];
};

export const TermiteLinks = ({ zone, place }) => (
  <section className="py-16 md:py-20" data-testid="termite-links">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
      <Reveal>
        <div className="rounded-[28px] border border-moss/15 bg-sand/50 p-7 md:p-10 grid lg:grid-cols-[1fr_1.3fr] gap-8 items-center">
          <div className="flex items-center gap-5">
            <img src="/images/logo-termite-habitat-33.webp" alt="Logo Termite Habitat 33, spécialiste termites en Gironde" loading="lazy" className="w-20 h-20 md:w-24 md:h-24 object-contain shrink-0" />
            <div>
              <p className="eyebrow text-sage">Aussi notre métier</p>
              <h2 className="mt-3 font-display text-2xl md:text-3xl font-extrabold text-forest leading-tight">Un problème de termites{place ? ` à ${place}` : ""} ?</h2>
              <p className="mt-2 text-[15px] text-ink/75">Termite Habitat 33 traite aussi les termites dans toute la Gironde, avec une garantie de 5 ans sur son travail.</p>
            </div>
          </div>
          <ul className="grid sm:grid-cols-2 gap-3">
            {pick(zone).map(i => TERMITE_LINKS[i]).map(l => (
              <li key={l.href}>
                <a href={l.href} target="_blank" rel="noopener" className="group flex items-center justify-between gap-3 rounded-2xl bg-white border border-moss/15 px-5 py-4 font-semibold text-forest hover:border-moss transition-colors" data-testid="termite-link">
                  {l.label}<ArrowUpRight className="w-4 h-4 shrink-0 text-moss transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
